import React from 'react';

import { FormattedMessage } from '../../util/reactIntl';
import { isTooManyRequestsError } from '../../util/errors';
import { shouldShowRateLimitPage } from '../../util/sharetribeRateLimit';

import { H3, H5 } from '../../components';

import css from './SearchPage.module.css';

/**
 * Search listing API error and invalid dates filter messages shared by map and grid variants.
 *
 * @param {Object} props
 * @param {boolean} [props.searchListingsError] - Truthy when search failed
 * @param {boolean} props.isValidDatesFilter - False when URL dates conflict with selected filter
 * @returns {JSX.Element}
 */
const SearchErrors = ({ searchListingsError, isValidDatesFilter }) => {
  const isRateLimited =
    isTooManyRequestsError(searchListingsError) ||
    (searchListingsError && shouldShowRateLimitPage(searchListingsError));
  return (
    <>
      {searchListingsError ? (
        <H3 className={css.error}>
          <FormattedMessage
            id={isRateLimited ? 'SearchPage.searchRateLimited' : 'SearchPage.searchError'}
          />
        </H3>
      ) : null}
      {!isValidDatesFilter ? (
        <H5>
          <FormattedMessage id="SearchPage.invalidDatesFilter" />
        </H5>
      ) : null}
    </>
  );
};

export default SearchErrors;
